'use es6';

import { combineReducers } from 'redux';
import promptDismissals from './promptDismissals';
import sessionData from './sessionData';
export default combineReducers({
  promptDismissals,
  sessionData
});